import { render } from "./NoProviderReference.vue?vue&type=template&id=1fab3f14&scoped=true&ts=true"
import script from "./NoProviderReference.vue?vue&type=script&lang=ts"
export * from "./NoProviderReference.vue?vue&type=script&lang=ts"

import "./NoProviderReference.vue?vue&type=style&index=0&id=1fab3f14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fab3f14"]])

export default __exports__